export default __webpack_public_path__ + "static/media/doctor-2.2abc516a.png";